export enum WovenLabelPositionType {
  BelowNeckTape = "Below neck tape (5mm)",
  OnNeckTape = "On neck tape",
}
